import React from 'react'
import baseStyle from './styles'
import DebanshuLogoCircle from '../../../public/images/DebanshuLogoCircle.png'
function displayBrand() {
  const classes = baseStyle()
  return (
    <div className={classes.displayBrandBase}>
      <img src={DebanshuLogoCircle} alt="logo" className={classes.logo} />
      <text className={classes.logoText}>Debanshu</text>
    </div>
  )
}

export default displayBrand
